import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { DATASOURCE } from '../../constants/apiConstants';
import {
  clearDataTableQueryParams,
  clearDateRange,
  clearSearchTerm,
} from '../../store/actions/dataTableActions';

const getModuleKey = (pathname: string): string | null => {
  if (pathname.startsWith('/admin')) {
    return '/admin';
  }

  if (pathname.startsWith('/geotrax/orders')) {
    return '/geotrax/orders';
  }

  return null;
};

const ADMIN_SOURCES: string[] = [
  DATASOURCE.DRIVER,
  DATASOURCE.USER,
  DATASOURCE.VEHICLE,
  DATASOURCE.VEHICLE_TYPE,
  DATASOURCE.HAULER,
  DATASOURCE.GEOZONE,
  DATASOURCE.PLANT,
  DATASOURCE.SCALE,
  DATASOURCE.DEVICE,
  DATASOURCE.REGION,
  DATASOURCE.CHECKLIST,
  DATASOURCE.TICKET,
  DATASOURCE.PERMISSION_GROUP,
  DATASOURCE.PERMISSION_USER,
];

const ORDERS_SOURCES: string[] = [DATASOURCE.ORDER];

const clearSources = (dispatch: any, sources: string[]) => {
  sources.forEach(source => {
    dispatch(clearSearchTerm(source));
    dispatch(clearDateRange(source));
    dispatch(clearDataTableQueryParams(source));
  });
};

export default function DataTableModuleBoundaryReset(): null {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const prevModuleKeyRef = React.useRef<string | null>(getModuleKey(location.pathname));

  React.useEffect(() => {
    const unlisten = history.listen(nextLocation => {
      const prevModuleKey = prevModuleKeyRef.current;
      const nextModuleKey = getModuleKey(nextLocation.pathname);

      if (prevModuleKey && prevModuleKey !== nextModuleKey) {
        if (prevModuleKey === '/admin') {
          clearSources(dispatch, ADMIN_SOURCES);
        }

        if (prevModuleKey === '/geotrax/orders') {
          clearSources(dispatch, ORDERS_SOURCES);
        }
      }

      prevModuleKeyRef.current = nextModuleKey;
    });

    return () => {
      unlisten();
    };
  }, [dispatch, history]);

  return null;
}
